module.exports = __webpack_public_path__ + "media/application/images/unesco@2x-49fb30e06de9a2e58d2f4784577c4a5740c7ac3432ec650442a95233ada59a7a.png";